<template>
    <div class="course-container">
        <!-- 顶部导航栏 -->
        <div class="top-nav">
            <div class="back-container" @click="changeModel">
                <el-icon :size="16"><ArrowLeftBold /></el-icon>
                <span>返回</span>
            </div>
            <div class="top-nav-title text-one" :title="form.name">{{ form.name }}</div>
        </div>

        <el-row class="course-main">
            <!-- 章节目录 -->
            <el-col class="btx" :span="6">
                <div id="vdWidth" class="custtoo tree-panel">
                    <div class="tree-panel-header">章节目录</div>
                    <div class="tree-panel-body">
                        <el-tree :data="dataSource" highlight-current ref="tree" @node-click="changeTree"
                                 :props="{ label: 'name', id: 'coursewareId', children: 'childrenList' }" node-key="coursewareId"
                                 default-expand-all :expand-on-click-node="false">
                            <template #default="{ node, data }">
                                <div class="custom-tree-node" style="display: flex;">
                                    <div style="flex: 1;align-items: center; display: flex;" :title="node.label">
                                        <el-icon :size="17" v-if="data.swfList && data.swfList.length != 0">
                                            <VideoPlay /> &nbsp;
                                        </el-icon>
                                        <div :style="'width:' + (vdWidth - 50) + 'px;'" class="text-one" style="">{{ node.label
                                            }}
                                        </div>
                                    </div>
                                    <div v-if="isLook == 0">
                                        <a title="新增视频" v-if="isType == node.level" style="margin-left: 8px"
                                           @click.stop="addVideo(data)"><el-icon :size="17">
                                            <FolderAdd />
                                        </el-icon></a>
                                        <a title="新增" v-if="node.level != 3 && (isVideo == 0 ? true : (isVideo != node.level))"
                                           style="margin-left: 8px" @click.stop="append(data)"><el-icon :size="17">
                                            <Plus />
                                        </el-icon></a>
                                        <a title="编辑" style="margin-left: 8px" @click.stop="editCourse(data)"><el-icon
                                          :size="17">
                                            <EditPen />
                                        </el-icon></a>
                                        <el-popconfirm confirm-button-text="是" cancel-button-text="否" :icon="InfoFilled"
                                                       icon-color="#626AEF" title="确定删除该章节及其视频附件" @confirm="delCourse(node, data)">
                                            <template #reference>
                                                <a title="删除" v-if="node.level != 1" style="margin: 0 8px"> <el-icon :size="17">
                                                    <Delete />
                                                </el-icon></a>
                                            </template>
                                        </el-popconfirm>
                                    </div>
                                </div>
                            </template>
                        </el-tree>
                    </div>
                </div>
            </el-col>

            <!-- 课件内容 -->
            <el-col :span="18">
                <div class="content-panel">
                    <div class="cw-recommend">{{ form.recommend }}</div>
                    <div class="cw-section-title">课件</div>
                    <div class="cw-swf-list">
                        <div class="cw-swf-item cursor" v-for="item in activeObj.swfList" :key="item.swfId"
                             :class="{ 'cw-swf-item-active': activeVideo.swfId == item.swfId }"
                             @click="getActiveObj(item)">
                            <div class="cw-swf-cover">
                                <div class="cw-swf-name-box">{{ item.swfName }}</div>
                                <img @click="bfFlash(item.swfUrl)" class="cw-swf-play" src="../../assets/img/played.png" alt="">
                            </div>
                            <div class="cw-swf-name text-one" :title="item.swfName">{{ item.swfName }}</div>
                        </div>
                    </div>
                    <div class="cw-section-title mb10">附件</div>
                    <div class="cw-file-list">
                        <div @click="xz(item)" v-for="item in showFileList" class="cw-file-item csbbb cursor">
                            <el-icon :size="20" v-has-btn="'1,2'" @click.stop="handleDownload(item)" title="下载"
                                     class="eicon">
                                <Download />
                            </el-icon>
                            <img class="cw-file-img" :src="item.imgUrl + '/1.png'" alt="">
                            <div class="cw-file-name text-one" :title="item.fileName">{{ item.fileName }}</div>
                        </div>
                    </div>
                    <div style="width: 100%;" v-if="showFileList.length == 0">
                        <el-empty class="qun-empty" description="暂无附件" />
                    </div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import flvjs from 'flv.js/dist/flv.min.js'
import { ElMessageBox } from 'element-plus'
import { famousCourseCreate, coursewareInfo, famousCourseUpdate,
    famousCourseDel, famousCourseDeleteVideo } from "@/api/admin/famousCourse"
import { download } from "@/api/adminservice/public";
import { timestampToTime } from "@/utils/date";

export default {
    name: "coursewareInfo",
    components: {
    },
    props:{
        courseId:{
            type: String,
            default:null
        },
    },
    watch:{
        courseId(newValue,oldValue){
            this.getfamousCourseInfo()
        },
    },
    data() {
        return {
            showMode:'page',
            vdNodeList: [],
            timestampToTime,
            isshow: false,
            isMl: false,
            userId: '',
            content: '',
            activeVideo: {
                swfUrl: ''
            },
            userHeadImg: '',
            isLook: 1,
            isFamous: 0,
            isCollection: 0,
            isStudio: 0,
            isTeachStudio: 0,
            isStudioRoom: 0,
            isTraVourse: 1,
            isList: 0,
            isVideo: 0,// 1 课 2 章 3 节
            isType: 1, // 1 课 2 章 3 节
            addFileShow: false,
            showFileList: [],
            fileShow: false,
            addVideoShow: false,
            addVideoCourseId: '',
            addVideoId: '',
            appCourseRules: {
                name: [
                    { required: true, message: "请输入章节名称", trigger: "blur" }
                ],
            },
            appCourseShow: false,
            appCourseForm: {
                name: '',
                parentId: ''
            },
            fileList: [],
            treedata: [],
            dataSource: [],
            coursewareId: '',
            periodList: [],
            gradeList: [],
            subjectList: [],
            courseClassifyList: [],
            activeObj: {},
            userList: [],
            token: this.$storage.get("token"),
            // 遮罩层
            loading: true,
            // 非单个禁用
            single: true,
            editCourseShow: false,
            // 表单参数
            form: {
                periodKey: '',
                gradeKey: '',
                subjectKey: '',
                lessonLevelKey: '',
                title: '',
                leadUser: '',
                teamUsers: '',
                teamuseList: [],
            },
            vdWidth: 250,
            // 表单校验
            rules: {
            },
            delFileList: [],
            trainId: '',
            stageType: 0,
            flvPlayer: null,
            videoHeight: 500,
        };
    },
    created() {
    },
    mounted() {
        this.userId = JSON.parse(this.$storage.get("userInfo")).userId
        this.getfamousCourseInfo()
    },
    unmounted() {
    },
    computed: {
    },
    methods: {
        changeModel(){
            this.$emit('change-mode', this.showMode);
        },
        handleDownload(item) {
            console.log(item);
            download(item.fileUrl, item.fileName)
        },
        getVnList() {

        },
        getActiveObj(item) {
            this.flvPlayer = null
            this.isshow = false;
            this.activeVideo = item;
            this.getVnList()

            setTimeout(() => {
                this.isshow = true;
                console.log(this.activeVideo);
                this.showFileList = this.activeVideo.fileList;
            })
            console.log(item);

        },
        delFile(item) {
            console.log(item);
            var _this = this;
            ElMessageBox.confirm(
              '是否删除该视频及附件?',
              '删除',
              {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning',
              }
            ).then(() => {
                famousCourseDeleteVideo({ swfId: item.swfId }).then(res => {
                    if (res.data.code == 1) {
                        this.$message.success("删除成功");
                        this.getfamousCourseInfo()
                        // this.$emit('isTg', true);
                    } else {
                        this.$message.error("操作失败")
                    }
                })

            }).catch(() => {

            })

            console.log(item);
        },
        xz(item) {
            let routeUrl = this.$router.resolve({
                path: '/lessonFileDetail',// 这里的路径就可以正常的写，不需要添加_blank: true
                query: { data: JSON.stringify(item) }
            })
            window.open(routeUrl.href, '_blank')
            // download(item.fileUrl, item.fileName)
        },
        addFile(item) {
            // console.log(item);
            this.addVideoId = item.swfId
            this.fileList = [];
            this.addFileShow = true;
        },
        changeTree(data) {
            console.log(data);
            this.activeObj = data;
            this.showFileList = []
            if(this.activeObj.swfList){
                this.activeVideo.swfId =this.activeObj.swfList[0].swfId
                if(this.activeObj.swfList.length != 0){
                    this.showFileList = this.activeObj.swfList[0].fileList
                }
            }
        },
        append(data) {
            this.appCourseForm = {
                name: '',
                parentId: data.coursewareId
            }
            if (data.swfList.length != 0) {
                this.$message.error('该层有视频，无法创建下级')
            } else {
                this.appCourseShow = true;
            }

            // famousCourseChapter({
            //     name: '节点111',
            //     parentId: data.coursewareId
            // }).then(res => {

            // })
            console.log(data);
        },
        addVideo(data) {
            console.log(data);
            this.fileList = [];
            if (data.childrenList) {
                if (data.childrenList.length == 0) {
                    this.addVideoCourseId = data.coursewareId
                    this.addVideoShow = true;
                } else {
                    this.$message.error('请在最下一级添加视频')
                }
            } else {
                this.addVideoCourseId = data.coursewareId
                this.addVideoShow = true;
            }


        },
        editCourse(data) {
            this.appCourseForm = {
                name: data.name,
                parentId: data.coursewareId
            }
            this.editCourseShow = true;
        },
        delCourse(node, data) {
            console.log(node, data);
            famousCourseDel({ coursewareId: data.coursewareId }).then(res => {
                if (res.data.code == 1) {
                    this.$message.success("删除成功");
                    this.getfamousCourseInfo()
                } else {
                    this.$message.error("操作失败")
                }
            })
        },
        remove(node, data) {
            console.log(node, data);
        },
        checkCoverValidator(rule, value, callback) {
            if (this.form.courseCover != '') {
                callback()
            } else {
                callback(new Error('请上传封面'))
            }
        },

        getfamousCourseInfo() {
            console.log("课件详情："+this.courseId)
            if (this.courseId!==null&&this.courseId!==undefined&&this.courseId!==''){
                this.isType = 1;
                this.isVideo = 0;
                this.dataSource = [];
                coursewareInfo({ coursewareId: this.courseId, isTraVourse: this.isTraVourse }).then(res => {
                    this.form = res.data.data;
                    this.dataSource.push(this.form)
                    if (this.isLook == 0) {
                        var isz = false;
                        var isj = false;
                        if (this.form.swfList.length != 0) {
                            this.isVideo = 1;
                        } else {
                            this.isVideo = 0;
                        }
                        if (this.form.childrenList) {
                            this.form.childrenList.forEach(j => {
                                if (j.swfList.length != 0) {
                                    this.isVideo = 2;
                                }
                                if (j.childrenList) {
                                    j.childrenList.forEach(m => {
                                        if (m.swfList.length != 0) {
                                            this.isVideo = 3;
                                        }
                                        isj = true;
                                    })
                                } else {
                                    isz = true;
                                }

                            })
                        } else {

                        }
                        if (isj == true) {
                            this.isType = 3;
                        } else {
                            if (isz == true) {
                                this.isType = 2;
                            }
                        }
                        console.log(this.isType, this.isVideo);

                        // this.dataSource.push({
                        //     id: this.form.coursewareId,
                        //     label: this.form.name,
                        // })
                        console.log(this.dataSource);
                        if (this.activeObj.coursewareId) {
                            // this.form.forEach(e => {
                            if (this.form.childrenList) {
                                this.form.childrenList.forEach(j => {
                                    if (j.childrenList) {
                                        j.childrenList.forEach(m => {
                                            if (m.coursewareId == this.activeObj.coursewareId) {
                                                this.activeObj = m;
                                            }
                                            if (m.swfList && m.swfList.length != 0) {

                                            }
                                        })
                                    }
                                    if (j.swfList && j.swfList.length != 0) {

                                    }
                                    if (j.coursewareId == this.activeObj.coursewareId) {
                                        this.activeObj = j;
                                    }
                                })
                            }

                            if (this.form.coursewareId == this.activeObj.coursewareId) {
                                this.activeObj = this.form;
                            }
                            if (this.activeObj.swfList) {

                            } else {
                                this.activeObj = this.dataSource[0]
                            }
                            // })
                            this.$nextTick(() => {
                                // selectId：绑定的 node-key
                                this.$refs.tree.setCurrentKey(this.activeObj.coursewareId);
                            });
                        } else {
                            this.$nextTick(() => {
                                // selectId：绑定的 node-key
                                this.$refs.tree.setCurrentKey(this.dataSource[0].coursewareId);
                                this.activeObj = this.dataSource[0]
                            });
                        }
                    } else if (this.isLook == 1) {
                        if (this.form.swfList.length != 0) {
                            this.$nextTick(() => {
                                this.$refs.tree.setCurrentKey(this.dataSource[0].coursewareId);
                            });
                            this.activeObj = this.dataSource[0]
                            this.activeVideo = this.dataSource[0].swfList[0]
                            this.showFileList = this.activeVideo.fileList;

                        } else {
                            if (this.form.childrenList) {
                                try {
                                    this.form.childrenList.forEach(j => {
                                        if (j.childrenList) {
                                            j.childrenList.forEach(m => {
                                                if (m.coursewareId == this.activeObj.coursewareId) {
                                                    this.activeObj = m;
                                                    this.activeVideo = m.swfList[0]
                                                    this.showFileList = this.activeVideo.fileList;
                                                }
                                                if (m.swfList && m.swfList.length != 0) {
                                                    console.log(m.coursewareId);
                                                    this.activeObj = m;
                                                    this.activeVideo = m.swfList[0]
                                                    this.showFileList = this.activeVideo.fileList;
                                                    this.$nextTick(() => {
                                                        // selectId：绑定的 node-key
                                                        this.$refs.tree.setCurrentKey(m.coursewareId);
                                                    });
                                                    throw new Error()
                                                }
                                            })
                                        }
                                        if (j.swfList && j.swfList.length != 0) {
                                            console.log(j.coursewareId);
                                            this.activeObj = j;
                                            this.activeVideo = j.swfList[0]
                                            this.showFileList = this.activeVideo.fileList;
                                            this.$nextTick(() => {
                                                // selectId：绑定的 node-key
                                                this.$refs.tree.setCurrentKey(j.coursewareId);
                                            });
                                            throw new Error()
                                        }
                                    })
                                } catch (error) {
                                    console.log(error);
                                }

                            }
                        }
                        this.getVnList()
                    }
                    setTimeout(() => {
                        this.isshow = true;

                        setTimeout(() => {
                            var videoElement = document.getElementById('videoElement');
                            var videoType = this.activeVideo.swfUrl.substring(this.activeVideo.swfUrl.length - 3).toLowerCase()

                            this.flvPlayer = flvjs.createPlayer({
                                  type: videoType,
                                  isLive: true,
                                  hasAudio: true,
                                  url: this.activeVideo.swfUrl
                              },
                              {
                                  enableWorker: false, //不启用分离线程
                                  enableStashBuffer: false, //关闭IO隐藏缓冲区
                                  reuseRedirectedURL: true, //重用301/302重定向url，用于随后的请求，如查找、重新连接等。
                                  autoCleanupSourceBuffer: true //自动清除缓存
                              })
                            this.flvPlayer.attachMediaElement(videoElement);
                            this.$forceUpdate()
                            this.flvPlayer.load();
                            // this.flvPlayer.play();
                        }, 1000)

                    }, 500);

                })

            }

        },
        handleXTChange(file) {
            console.log(file)
        },
        handleJAChange(file) {
            console.log(file)
        },
        handleXAChange(file) {
            console.log(file);
        },
        handleKjChange(file) {
            console.log(file)

        },
        beforeJAUpload(rawFile) {
            console.log(rawFile)
            if (!(rawFile.type == 'application/pdf' || rawFile.type == 'application/vnd.ms-powerpoint' || rawFile.type == 'application/vnd.openxmlformats-officedocument.presentationml.presentation')) {
                this.$message.error('文件必须是.pdf,.ppt,.pptx格式的')
                return false
            } else if (rawFile.size / 1024 / 1024 > 200) {
                this.$message.error('文件大小不能超过200M')
                return false
            }
            return true
        },
        startDateConfirm(e) {
            if (e > this.form.endTime) {
                this.form.endTime = '';
            }
        },
        endDateConfirm(e) {
            console.log(e,)
            if (e < this.form.beginTime) {
                this.form.beginTime = '';
            }
        },
        checkValidator(rule, value, callback) {
            // rule规则对象
            // value关联表单值
            // callback() 回传结果
            if (this.form.beginTime === '' || !this.form.beginTime) {
                callback(new Error('请选择开始日期'))
            } else if (this.form.endTime === '' || !this.form.endTime) {
                callback(new Error('请选择结束日期'))
            } else {
                callback()
            }
        },
        disabledDate(current) {
            return current && current < Number(new Date()) - 86400000
        },
        enddisabledDate(current) {
            if (this.form.beginTime) {
                return current && current < this.form.beginTime
            } else {
                return current && current < Number(new Date()) - 86400000
            }
        },
        changePeriod() {
            this.form.gradeKey = '';
            this.form.subjectKey = '';
            this.gradeList = [];
            this.subjectList = [];
            this.periodList.forEach(j => {
                if (this.form.periodKey == j.dictKey) {
                    this.gradeList = j.childrenList;
                }
            })
        },
        bfFlash(url){
            let routeUrl = this.$router.resolve({
                path: '/lookflash',// 这里的路径就可以正常的写，不需要添加_blank: true
                query: { page: window.btoa(window.encodeURIComponent(url)) }
            })
            window.open(routeUrl.href, '_blank')
        },
        changeGrade() {
            this.form.subjectKey = '';
            this.subjectList = []
            this.periodList.forEach(e => {
                if (this.form.periodKey == e.dictKey) {
                    e.childrenList.forEach(j => {
                        if (this.form.gradeKey == j.dictKey) {
                            this.subjectList = j.childrenList;
                        }
                    })
                }
            })
        },
        getQueryDict() {
        },
        handleAvatarSuccess(response, uploadFile) {
            console.log(response, uploadFile);
            if (uploadFile.response.code == 1) {
                this.form.courseCover = uploadFile.response.data;
            } else {
                this.$message.error("上传失败")
            }

        },
        beforeAvatarUpload(rawFile) {
            console.log(rawFile)
            if (!(rawFile.type == 'image/jpeg' || rawFile.type == 'image/png' || rawFile.type == 'image/jpg')) {
                this.$message.error('图片必须是jpeg、png、jpg格式的')
                return false
            } else if (rawFile.size / 1024 / 1024 > 10) {
                this.$message.error('图片大小不能超过10M')
                return false
            }
            return true
        },
        /** 提交按钮 */
        submitForm() {
            console.log(this.form)

            this.$refs["form"].validate(valid => {
                if (valid) {
                    if (this.coursewareId) {
                        famousCourseUpdate(this.form).then(res => {
                            if (res.data.code == 1) {
                                this.$message.success("编辑成功");
                                this.replace('/famousCourse', { isSx: 1 })
                            } else {
                                this.$message.error("操作失败")
                            }
                        })
                    } else {
                        famousCourseCreate(this.form).then(res => {
                            if (res.data.code == 1) {
                                this.$message.success("新增成功");
                                this.replace('/famousCourse', { isSx: 1 })
                                // this.$emit('isTg', true);
                            } else {
                                this.$message.error("操作失败")
                            }

                        });
                    }

                }
            });
        },
        // 取消按钮
        cancel() {
            if(this.isTraVourse == 1){
                this.replace('/coursewareList')
            }else{
                this.replace('/courseware')
            }

            // this.$emit('isTg', true)
        },
    }
};
</script>
<style scoped>
.course-container {
    width: 100%;
    background: #f5f7fa;
    border-radius: 8px;
    padding: 10px 10px 0;
    box-sizing: border-box;
}

/* 顶部导航栏 */
.top-nav {
    display: flex;
    align-items: center;
    width: 100%;
    height: 48px;
    padding: 0 16px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 4px rgba(15, 35, 95, 0.06);
    box-sizing: border-box;
}

.back-container {
    display: flex;
    align-items: center;
    gap: 4px;
    height: 32px;
    padding: 0 10px;
    border-radius: 6px;
    cursor: pointer;
    color: #606266;
    font-size: 14px;
    flex-shrink: 0;
    transition: all 0.2s;
}

.back-container:hover {
    color: var(--el-color-primary);
    background: #f0f4fa;
}

.top-nav-title {
    margin-left: 12px;
    padding-left: 12px;
    border-left: 1px solid #e4e7ed;
    font-size: 15px;
    font-weight: 600;
    color: #303133;
}

.course-main {
    margin-top: 10px;
}

.btx {
    width: 300px;
    z-index: 999;
}

/* 章节目录面板 */
.tree-panel {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 242px);
    margin-right: 10px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 4px rgba(15, 35, 95, 0.06);
    overflow: hidden;
}

.tree-panel-header {
    flex-shrink: 0;
    padding: 12px 16px;
    font-size: 15px;
    font-weight: 600;
    color: #303133;
    border-bottom: 1px solid #f0f0f0;
}

.tree-panel-body {
    flex: 1;
    overflow: auto;
    padding: 8px;
}

.custtoo /deep/ .el-tree-node__label {
    flex: 1;
}

/* 课件内容面板 */
.content-panel {
    height: calc(100vh - 242px);
    overflow: auto;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 4px rgba(15, 35, 95, 0.06);
    padding: 16px;
    box-sizing: border-box;
}

.cw-recommend {
    font-size: 14px;
    color: #606266;
    line-height: 1.7;
}

.cw-section-title {
    margin-top: 20px;
    padding-left: 8px;
    border-left: 3px solid var(--el-color-primary);
    font-size: 15px;
    font-weight: 600;
    color: #303133;
    line-height: 1.2;
}

/* 课件卡片 */
.cw-swf-list {
    display: flex;
    flex-wrap: wrap;
}

.cw-swf-item {
    width: 320px;
    margin: 12px 12px 0 0;
    padding: 6px;
    border-radius: 6px;
    transition: background 0.2s;
}

.cw-swf-item:hover {
    background: #f5f7fa;
}

.cw-swf-cover {
    width: 100%;
    height: 180px;
    background: #034306;
    border-radius: 6px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;
    text-align: center;
    color: #fff;
    font-size: 18px;
}

.cw-swf-name-box {
    width: 200px;
    white-space: normal;
    word-wrap: break-word;
}

.cw-swf-play {
    width: 40px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

.cw-swf-name {
    margin-top: 6px;
    font-size: 14px;
    color: #303133;
}

.cw-swf-item-active .cw-swf-cover {
    box-shadow: 0 0 0 2px var(--el-color-primary);
}

.cw-swf-item-active .cw-swf-name {
    color: var(--el-color-primary);
}

/* 附件列表 */
.cw-file-list {
    display: flex;
    flex-wrap: wrap;
}

.cw-file-item {
    margin: 10px 10px 0 0;
    border: 1px solid #ebeef5;
    border-radius: 8px;
    overflow: hidden;
    transition: box-shadow 0.2s;
}

.cw-file-item:hover {
    box-shadow: 0 4px 12px rgba(15, 35, 95, 0.12);
}

.cw-file-img {
    display: block;
    width: 100px;
    height: 130px;
    object-fit: cover;
}

.cw-file-name {
    width: 100px;
    padding: 6px 4px;
    text-align: center;
    color: #303133;
    box-sizing: border-box;
}

.csbbb {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    position: relative;
}

.eicon {
    display: none;
    position: absolute;
    top: 6px;
    right: 6px;
    padding: 5px;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 4px;
    cursor: pointer;
    z-index: 99;
}

.csbbb:hover .eicon {
    display: block;
}
</style>